import { styled } from "@mui/material/styles";
import { Box, Button, Icon, IconButton, Typography } from "@mui/material";
import { useColors } from "../../Context/ColorsContext";
import { MediaQuerys } from "../../styles/GlobalStyle";

const { mobile, tablet, desktop, desktoplarge } = MediaQuerys;

export const PageTitle = styled('p')(() => {
  const { colors } = useColors();
  return {
    color: colors.titleTextColor,
    alignContent: "center",
    textAlign: "left",
    fontWeight: "700",
    fontSize: '24px',
    [mobile]: {
      fontSize: '18px',
    },
  };
});

export const TableWrapperOverrides = styled('div')(({ theme }) => {
  const { colors } = useColors();

  return {
    "& .MuiPaper-root": {
      borderRadius: "10px",
    },
    "& .MuiTableContainer-root": {
      height: 'calc(100vh - 300px)',
      borderRadius: "8px",
      [theme.breakpoints.up('sm')]: {
        height: 'calc(100vh - 270px)'
      },
      [theme.breakpoints.up('md')]: {
        height: 'calc(100vh - 230px)'
      },
    },
    "& .MuiTableHead-root .MuiTableRow-head": {
      borderRadius: "10px",
    },
    "& .MuiTableHead-root .MuiTableCell-root span": {
      fontSize: "14px",
      lineHeight: 1.2,
      fontWeight: 600,
      color: colors.navbarColor,
      [tablet]: {
        fontSize: "12px",
      }
    },
    "& .MuiTableHead-root .MuiTableCell-root": {
      paddingTop: "8px !important",
      paddingBottom: "8px !important",
      background: "#eeeeee",
      borderTop: "none",
      borderBottom: "none",
    },
    "& .MuiTableBody-root .MuiTableRow-root .MuiTableCell-root": {
      padding: "6px 10px",
      fontSize: "14px !important",
      fontWeight: 'auto',
      [tablet]: {
        fontSize: "12px !important",
      },
    },
  };
});

export const Container = styled(Box)(
  ({ theme, open, isExternal, customWidth, isModal }) => ({
    [theme.breakpoints.up("md")]: {
      width: setSize(open, isExternal, customWidth),
    },
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginTop: 8,
    marginBottom: isModal ? 8 : 50,
    flexGrow: 1,

  })
);

export const ContainerTitle = styled('div')(() => {
  return {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
  }
})

export const ContainerButtoms = styled('div')(() => {
    return {
        height: 34,
        width: 250,
        float: 'right'
    }
})

export const CustomButton = styled(Button)(({disabled}) => {
    const { colors } = useColors();
    return {
        height: '100%',
        width: '100%',
        padding: "0 20px",
        backgroundColor: disabled ? colors.grayFont : colors.buttonActionColor,
        color: colors.white,
        "&:hover": {
            backgroundColor: disabled ? colors.grayFont : colors.buttonActionColor,
            opacity: 0.9,
            color: colors.white
        }
    }
})

export const ContainerButtonCreate = styled('div')(() => ({
  width: 170,
  height: 40,
  [desktop]: {
    width: "120px",
    height: "30px",
    "& button": {
      padding: "14px 12px",
      fontSize: "0.55rem",
    },
  },
  [tablet]: {
    width: "110px",
    height: 20,
    "& button": {
      fontSize: "7px",
    },
  },
}))

export const CustomIconButton = styled(IconButton)(({iconColor}) => {
    const { colors } = useColors();
    return {
        borderRadius: '8px',
        width: '28px',
        height: '28px',
        margin: '0 2px',
        backgroundColor: colors.background,
        color: iconColor ? colors[iconColor] : colors.buttonActionColor,
        "&:hover": {
            backgroundColor: iconColor ? colors.background : colors.buttonActionColor,
            opacity: 0.9,
            color: colors.background,
        },
        [tablet]: {
            height: 28,
            width: 28,
        },
    }
})

export const BoxModal = styled(Box)(() => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
}));

export const Text = styled(Typography)((props) => {
  const { colors } = useColors();
  return {
    fontSize: '12px',
    fontWeight: 600,
    color: colors.white,
    maxWidth: '100px',
    backgroundColor: `${props.enabled ? colors.green : colors.darkOrange}`,
    alignItems: 'center',
    textAlign: 'center',
    borderRadius: '5px',
    padding: '1px 1.5px',
    [desktop]: {
      fontSize: '0.75rem',
    }
  }
})

export function getStatusLabel(value, status, sizeText) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { colors } = useColors();

    return <div>
      <Text sx={{ color: colors.white, fontSize: sizeText || 14 }} enabled={value}>{status}</Text>
    </div>
}